import {Component, Injector, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {AUDITTRAILINFO, CARDINFO} from '../../../../gen/swagger-api';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ModalBaseComponent} from '../modal-base-component';
import {DefaultService} from "../../../../gen/swagger-api/api/default.service";

@Component({
  selector: 'app-history-modal',
  templateUrl: './history-modal.component.html',
  styleUrls: ['./history-modal.component.css']
})
export class HistoryModalComponent extends ModalBaseComponent implements OnInit {
  callback;
  bsModalRef: BsModalRef;
  subscription: CARDINFO;
  historyItems: Array<AUDITTRAILINFO>;
  downloadJsonHref: SafeUrl;

  constructor(private inject: Injector, private _bsModalRef: BsModalRef,
    private defaultService: DefaultService,
    private sanitizer: DomSanitizer) {
      super(inject);
     }

  ngOnInit() {
    this.loadHistory();
  }

  generateDownloadJsonUri() {
    var theJSON = JSON.stringify(this.historyItems);
    var uri = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(theJSON));
    this.downloadJsonHref = uri;
}

  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public refresh(){
    this.loadHistory();
  }

  public loadHistory(): void {
    this.defaultService.cardsEidAuditGet(this.subscription.eis.eid).subscribe(
      historyItems => this.historyItems = historyItems,
      console.error,
      () => {
        console.log('History loaded');
        this.generateDownloadJsonUri();
        this.callback();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/history-modal/history-modal.component.ts